import { fetchAuthSession } from "aws-amplify/auth";
import * as Sentry from "@sentry/browser";

export const getRefreshedAccessToken = async () => {
  const authSession = await fetchAuthSession({ forceRefresh: true });
  if (!authSession || !authSession.tokens) {
    return "";
  }
  return authSession.tokens.accessToken.toString();
};

// Called by native to mint a fresh token mid-flow and reply over the WebView bridge.
export const getFreshTokenForNative = async (): Promise<void> => {
  try {
    const token = await getRefreshedAccessToken();
    if (!token) return;
    window.ReactNativeWebView?.postMessage(JSON.stringify({ type: "tokenRefreshed", data: { token } }));
  } catch (err) {
    Sentry.captureMessage(
      `getFreshTokenForNative failed: ${err instanceof Error ? err.name : "unknown"}`,
      { level: "warning" }
    );
  }
};
